import { Component, OnInit } from '@angular/core';
import { Product } from '../product';
import { CategoryService } from '../../categories/category.service';

import { ManufactureService } from '../../manufacturers/manufacture.service';
import { CurrencyService } from '../../currencies/currency.service';
import { UnitService } from '../../units/unit.service';

import { Location } from '@angular/common';
import { Router } from '@angular/router';


import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../product.service';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-product-crud',
  templateUrl: './product-crud.component.html',
  styleUrls: ['./product-crud.component.css'],
  providers: [
              ProductService,
              ManufactureService,
              CurrencyService,
              UnitService,
              CategoryService
              ]
})

export class ProductCrudComponent implements OnInit {


  id: any = null;
  product: Product;
  productForm: FormGroup;
  photos:any[]=[];
  photo_handler: any[]=[];
  msgs: Message[] = [];
  loading: boolean = false;
  manufacturer: any;
  currency: any;
  categoryFetch: any = [];
  selectedUnit: string;
  selectedUnitDetail: string;
  selectedCategory: string;
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";
  uploadedFiles: any[] = [];

 

  constructor(
    private productService: ProductService,
    private manufactureService: ManufactureService,
    private currencyService: CurrencyService,
    private categoryService: CategoryService,
    private unitService: UnitService,
    private fb: FormBuilder,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute) {

  		 activatedRoute.params.subscribe(params=>{this.id=params['id']});
    
         this.productForm = this.fb.group({
            'name': new FormControl('',Validators.required),
            'sku': new FormControl('',Validators.required),
            // 'bar_code': new FormControl(),
            // 'oem': new FormControl(),
            // 'summary': new FormControl(),
            'description': new FormControl(),
            'category_id': new FormControl('',Validators.required),
            'photos[]': new FormControl(),
            // 'photos': new FormControl(),
            'unit_id': new FormControl('',Validators.required),
            'detail_unit_id': new FormControl(),
            'detail_unit_value': new FormControl(),
            'weight': new FormControl(),
            // 'manufacturer_id': new FormControl('',Validators.required),
            'min_count_for_notice': new FormControl(),
            // 'sort': new FormControl(),
            'available': new FormControl('',Validators.required)
        }); 




   		  if(this.id){
          this.loading=true;  
   		  	this.productService.getProductById(this.id).subscribe(response=>{
//                  this.unitService.getUnit().subscribe(response=>{
//                             this.products.units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
//                             this.selectedUnit=this.products['unit'].id;
//                  })

//                  this.unitService.getUnit().subscribe(response=>{
//                             this.products.units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
//                             this.selectedUnit=this.products['unit'].id;
//                  })
// //               
                 // this.currencyService.getCurrency().subscribe(response=>{
                 //            this.products.currencies=response.data.map(function(value: any){return {label:value.name, value: value.id};});
                 //            this.selectedCurrency=this.products['currency'].id;
                 // })

                 // this.manufactureService.getManufactureList().subscribe(response=>{
                 //            this.products.manufacturers=response.data.map(function(value: any){return {label:value.name, value: value.id};});
                 //            this.selectedManufacturer=this.products['manufacturer'].id;
                 // })
                      let images = response['data'].photos;
                      let path = response['data'].photo_path;
                      console.log(images); 
                      let i=0;
                      for (var item in images){
                        this.photos.push({index: i,productId: this.id, imageId: item, src: path+"/"+images[item]});
                        i++;
                      }
                      console.dir(this.photos);  

                      this.unitService.getUnit(1).subscribe(response=>{
                            this.product.units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
                       });
                       this.unitService.getUnit(1).subscribe(response=>{
                            this.product.detail_units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
                       });

                      this.categoryService.getCategory(1).subscribe(response=>{
                          this.recarray(response['data'],'children',this);
                           this.product.categories=this.categoryFetch.map(function(value: any){
                                                        return {label:value.name, value: value.id};
                                                   });  
                       this.loading=false;
                       });
                    
                   this.selectedCategory = response['data'].category.id;
                   this.selectedUnit = response['data'].unit.id;

                   if(response['data'].detail_unit)
                   {
                       this.selectedUnitDetail = response['data'].detail_unit.id;
                   }
                   // this.product=response['data'];

                   for(let item in response['data']){
                     
                     if(response['data'][item] || item=='available'){
                         this.product[item]=response['data'][item];
                     }
                  
                   }  
                   

                   // this.loading=false;
                    

           });	
    
                     
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
            
   		  }else{
                 this.unitService.getUnit(1).subscribe(response=>{
                            this.product.units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
                 });
                 this.unitService.getUnit(1).subscribe(response=>{
                            this.product.detail_units=response.data.map(function(value: any){return {label:value.name, value: value.id};});  
                 });

                 this.categoryService.getCategory(1).subscribe(response=>{
                      this.recarray(response['data'],'children',this);
                      this.product.categories=this.categoryFetch.map(function(value: any){
                                                        return {label:value.name, value: value.id};
                                             });  
                 });

                 // this.manufactureService.getManufactureList().subscribe(response=>{
                 //            this.products.manufacturers=response.data.map(function(value: any){return {label:value.name, value: value.id};});
                 // })
       

         }

   }

  ngOnInit() {

  	this.product={
            name: "",
            sku: "",
            // bar_code: "",
            // oem: "",
            // summary: "",
            // description: "",
            categories: [],
            // photos: "",
            units: [],
            detail_units: [],
            // detail_unit_value: "",
            // weight: "",
            manufacturer_id: [],
            // min_count_for_notice: "",
            // sort: "",
            available: true
    }
    
    // this.photos=[];


  }

    // onUpload(event : any) {
    //     for(let file of event.files) {
    //         this.uploadedFiles.push(file);
    //     }
    
    //     this.msgs = [];
    //     this.msgs.push({severity: 'info', summary: 'File Uploaded', detail: ''});
    // }
  deleteImg(index: any, productId:any,imageId: any){
    this.photos.splice(index,1);
    this.productService.deleteImage(productId,imageId).subscribe(response=>console.log(response));
  }

  backClicked() {
        this.location.back();
  }

  addPhoto(event){
     // let reader = new FileReader();
       let target = event.target || event.srcElement;

       for (let item of target.files){
               this.photo_handler.push(item);
       }

     // reader.readAsDataURL(file);

    // reader.onload = () => {
        // this.photo_handler.push(reader.result.split(',')[1]);
      // };
      // console.log(file);      
    // console.log(file);
    console.log(this.photo_handler);
  }

  recarray(ar: any, searchfor: any,that: any) {
          ar.forEach(function(item: any,i: any,arr: any){
              if(item instanceof Object){
                  if("children" in item){
                     that.recarray(item['children'],searchfor,that)
                  }
                  that.categoryFetch.push(item);
              }
          });
  }


 crud(form):void{

       console.log(form.value);

        let input = new FormData();

        for(let item in form.value){
          console.log("IF--"+form.value[item]);
          console.log("item--"+item);
          console.log("form.value[item]"+form.value[item]);
            if(form.value[item] || item=="available"){
              if(item=='available'){
                form.value[item] = form.value[item] == true ? 1 : 0;  
              }
              input.append(item,form.value[item]);
            }
        }

        if(this.photo_handler.length>0){   
        console.log("USLOVIYA IMAGE");     
            for(let item of this.photo_handler){
                input.append('photos[]', item,item['name']); 
            }
        }
        console.log(input);
        // input.append('photos[]', this.photo_handler[0],"photocha2"); 
        // input.append('testphoto', this.photo_handler[0],"photocha2"); 
        // input.append('available', form.value['available']); 
   		  if(!this.id){
            this.loading=true; 
            // form.value['photos[]']=this.photo_handler[0];
            console.log(form.value);
   		  		this.productService.createProduct(input)
   		  		.subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/product']);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});

   		  }else{
          this.loading=true; 
          console.log(input);
   		  	this.productService.updateProduct(input,this.id)
   		  		.subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/product']);}
                  , (error)=>{this.loading=false;let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
   		  }



  }	  



}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/products/product-crud/product-crud.component.ts